import log from 'salvo-lite/log'

class Thumbnails {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = JSON.parse(elem.getAttribute('data-thumbnail'))
        this._index = this._data.index
        this._imageUrl = this._data.imageUrl || false
        this._mainImageWrapper = document.querySelector('[data-main-image-wrapper]')
        this._alt = elem.querySelector('img').alt
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elem.addEventListener('click', () => {
            if (this._imageUrl) {
                this._changeImage()
            }
            if (this._data.video) {
                this._changeVideo()
            }
        })
    }

    _changeImage () {
        this._mainImageWrapper.querySelector('img').src = this._imageUrl // update image src
        this._mainImageWrapper.querySelector('img').alt = this._alt // update alt text

        this._mainImageWrapper.querySelector('img').classList.remove('visually-hidden')
        this._mainImageWrapper.querySelector('div:not(.visually-hidden)').classList.add('visually-hidden')

        // this._mainImageWrapper.nextElementSibling.textContent = this._alt // update alt text caption
    }

    _changeVideo () {
        this._mainImageWrapper.querySelector('img').classList.add('visually-hidden')
        this._mainImageWrapper.querySelector(`[data-count="${this._index}"]`).classList.remove('visually-hidden')
    }
}

export default Thumbnails



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Thumbnails.js